export default __webpack_public_path__ + "static/media/placeholder_business01-nl-web.d173f4e0.png";